import { render, staticRenderFns } from "./UrnSalesForm.vue?vue&type=template&id=48a6b0ef&"
import script from "./UrnSalesForm.vue?vue&type=script&lang=js&"
export * from "./UrnSalesForm.vue?vue&type=script&lang=js&"
import style0 from "./UrnSalesForm.vue?vue&type=style&index=0&id=48a6b0ef&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports